import { rgba } from "polished";
import styled, { css } from "styled-components/macro";

import { Spacer } from "shared/layout";
import { FlexContainer, MutedText } from "shared/styles";
import {
  borderRadius,
  colors,
  fontSize,
  fontStyle,
  space,
} from "shared/styles/constants";

interface StageInfoContainerProps {
  isActive?: boolean;
}

export const StageInfoContainer = styled(Spacer)<StageInfoContainerProps>`
  && {
    margin-top: ${space.xl};

    ${({ isActive }) =>
      isActive &&
      css`
        padding: ${space.xxs} ${space.xs};
        border-radius: ${borderRadius.s};
        border: 1px solid ${rgba(colors.yellow, 0.5)};
        background-color: ${rgba(colors.yellow, 0.1)};
      `}
  }
`;

export const StageCapacities = styled.div`
  display: flex;
  flex-wrap: wrap;

  width: 100%;
  margin: calc(-${space.xxs} / 2) -${space.xxs};

  text-align: left;

  > * {
    margin: calc(${space.xxs} / 2) ${space.xxs};
  }
`;

export const StageCapacity = styled(MutedText)`
  color: ${colors.grey4};

  > * + * {
    margin-left: ${space.xxs};
  }
`;

export const LogoContainer = styled.img`
  overflow: hidden;

  width: 80px;
  height: 80px;
  object-fit: cover;

  border-radius: 50%;

  margin-bottom: ${space.s};
`;

export const ContactInfoContainer = styled.div`
  && {
    display: flex;

    flex-wrap: wrap;

    margin: -${space.xxs} -${space.s};

    > * {
      padding: ${space.xxs} ${space.s};
    }

    @media print {
      * {
        color: ${colors.grey2};
      }
    }
  }
`;

export const VenueTitleContainer = styled(FlexContainer)`
  a {
    text-decoration: none;
    border: none !important;

    color: ${colors.white} !important;
  }

  @media print {
    a {
      color: ${colors.black} !important;
      font-size: ${fontSize.xxs} !important;
      font-weight: ${fontStyle.bold};
    }
  }
`;
